import DogImage from './DogImage';

export default DogImage;